<template>
    <div class="dc-login is-document">
        <el-card class="dc-login__card is-document">
            <div class="clearfix title" slot="header">
                <h3>Document Delivery</h3>
            </div>
            <div class="dc-login__card-text">
                <p>By default, you are enrolled in our paperless tax document delivery service. In order to receive your tax documents your email associated with your Primior Account must be up to date. If you would like a paper copy of your tax documents, you can print one from the Tax Center.</p>
                <p>If you would like to opt-out of our paperless tax document delivery service you can do so by selecting “Paper Delivery” below.</p>
            </div>
            <div class="dc-login__card-subtext">
                <ol>
                    <li>By selecting "electronic paperless delivery", You are consenting to have your tax documents be provided via electronic paperless delivery rather than paper delivery via mail.</li>
                    <li>This consent will apply until such time as you have withdrawn your consent.</li>
                    <li>Consent can be withdrawn at anytime via email contact@primior.com or mail to Primior Support</li>
                    <li>A PDF reader is required to download and print any of these documents.</li>
                    <li>Your tax documents will remain available electronically on the Primior website so long as you have an account.</li>
                </ol>
            </div>
            <div class="dc-login__card-radio">
                <el-radio v-model="radio" label="1" @change="changeRadio">Electronic Paperless Delivery</el-radio>
                <el-radio v-model="radio" label="2" @change="changeRadio">Paper Delivery</el-radio>
            </div>
            <div class="dc-login__card-footer clearfix">
                <el-button type="primary" class="float-right dc-login__button" @click="$router.go(-1)">Save</el-button>
                <el-button class="float-right dc-login__button" @click="$router.go(-1)">Cancel</el-button>
            </div>
        </el-card>
    </div>
</template>

<script>
import {getLocalstorage, setLocalstorage} from '../../common/storage';

export default {
    name: 'document',
    data () {
        return {
            radio: '1'
        }
    },
    mounted () {
        this.radio = getLocalstorage('dc-doc-delivery') || '1'
    },
    methods: {
        changeRadio () {
            setLocalstorage('dc-doc-delivery', this.radio)
        }
    }
}
</script>